import {StatusHistoryItem} from "../../../components/StatusHistoryItem.tsx";
import React, {useState} from "react";
import SamButton from "../../../components/SamButton.tsx";
import Modal from "../../../components/Modal.tsx";
import {UpdateStatusAsMessageForm} from "../../../components/UpdateStatusAsMessageForm.tsx";
import {FullStatus, UserType} from "../../../api/ApiTypes.ts";

interface HistoryTabProps {
    orderId?: number
    histories?: FullStatus[]
    userType?: UserType
}

export const HistoryTab: React.FC<HistoryTabProps> = ({ histories, orderId, userType }) => {

    const [ isUpdateStatusModalOpen, setIsUpdateStatusModalOpen ] = useState<boolean>(false);
    if (!orderId) {
        return (
            <div className="bg-white rounded-lg p-6 text-center border border-slate-200">
                <p className="text-slate-500">Order ID is not available.</p>
            </div>
        )
    }
    // If no history data or empty array, show a message
    if (!histories || histories.length === 0) {
        return (
            <div className="bg-white rounded-lg p-6 text-center border border-slate-200">
                <p className="text-slate-500">No history records available for this order.</p>
            </div>
        );
    }

    // Sort histories by date (newest first)
    const sortedHistories = [...histories].sort((a, b) =>
        new Date(b.statusDate).getTime() - new Date(a.statusDate).getTime()
    );

    const handleSuccess = () => {

        setIsUpdateStatusModalOpen(false);
    };

    const handleCancel = () => {

        setIsUpdateStatusModalOpen(false);
    }

    return (
        <div className="space-y-2">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-medium text-slate-800">Order History</h2>
                {userType && userType !== UserType.STAFF && (
                    <SamButton
                        onClick={() => setIsUpdateStatusModalOpen(true)}
                    >
                        Update Status
                    </SamButton>
                )}
            </div>

            {sortedHistories.map(status => (
                <StatusHistoryItem key={status.id} status={status} />
            ))}

            <Modal isOpen={isUpdateStatusModalOpen}
                   onClose={()=> setIsUpdateStatusModalOpen(false)}
                   title={"Update Status"}
            >
                <UpdateStatusAsMessageForm
                    orderId={orderId}
                    onSuccess={handleSuccess}
                    onCancel={handleCancel}
                />
            </Modal>
        </div>
    );
};